import React from "react";

import {
  Card,
  Typography,
} from "antd";

import {
  TeamOutlined,
  SafetyCertificateOutlined,
  CalendarOutlined,
  SolutionOutlined,
} from "@ant-design/icons";

import { motion } from "framer-motion";

const { Text } = Typography;

const YearlyDeanOfficialCount = ({ theme }) => {
  return (
    <motion.div
      initial={{
        opacity: 0,
        y: 10,
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      whileHover={{
        y: -5,
        transition: {
          duration: 0.2,
        },
      }}
      style={{
        height: "100%",
      }}
    >
      <Card
        bordered={false}
        style={{
          height: "100%",
          minHeight: 218,
          borderRadius: 22,
          overflow: "hidden",
          position: "relative",
          background: theme.card,
          border: `1px solid ${theme.border}`,
          boxShadow: "0 14px 40px rgba(6,42,75,.07)",
        }}
        styles={{
          body: {
            padding: 0,
            height: "100%",
          },
        }}
      >
        {/* Top accent */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: 4,
            background:
              "linear-gradient(90deg,#062A4B,#0F6DAB,#4FAE22)",
          }}
        />

        <div
          style={{
            padding: 22,
            height: "100%",
            boxSizing: "border-box",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 9,
              }}
            >
              <div
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: 13,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background:
                    "linear-gradient(135deg,#062A4B,#0F6DAB)",
                  color: "#fff",
                  fontSize: 20,
                  boxShadow:
                    "0 7px 18px rgba(6,42,75,.22)",
                }}
              >
                <TeamOutlined />
              </div>

              <div>
                <Text
                  style={{
                    display: "block",
                    color: theme.text,
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Dean of Students
                </Text>

                <Text
                  style={{
                    color: theme.secondary,
                    fontSize: 11,
                  }}
                >
                  Student Affairs & Welfare
                </Text>
              </div>
            </div>
          </div>

          {/* Main Function */}
          <div
            style={{
              marginTop: 18,
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <SolutionOutlined
              style={{
                color: "#0F6DAB",
                fontSize: 19,
              }}
            />

            <span
              style={{
                fontSize: 24,
                lineHeight: 1.15,
                fontWeight: 800,
                letterSpacing: "-0.5px",
                color: theme.text,
              }}
            >
              Student Welfare
            </span>
          </div>

          <Text
            style={{
              display: "block",
              marginTop: 7,
              color: theme.secondary,
              fontSize: 12,
              lineHeight: 1.5,
            }}
          >
            Coordinate student welfare, discipline, attendance,
            counseling, engagement, and general student support.
          </Text>

          {/* Responsibilities */}
          <div
            style={{
              marginTop: 18,
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 10,
            }}
          >
            {/* Discipline */}
            <div
              style={{
                padding: "11px 12px",
                borderRadius: 14,
                background:
                  theme.mode === "dark"
                    ? "rgba(6,42,75,.18)"
                    : "#F4F8FA",
                border: `1px solid ${theme.border}`,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 7,
                }}
              >
                <SafetyCertificateOutlined
                  style={{
                    color: "#062A4B",
                  }}
                />

                <Text
                  style={{
                    color: theme.secondary,
                    fontSize: 11,
                  }}
                >
                  Discipline
                </Text>
              </div>

              <strong
                style={{
                  display: "block",
                  marginTop: 4,
                  color: theme.text,
                  fontSize: 13,
                  lineHeight: 1.3,
                }}
              >
                Student Conduct
              </strong>
            </div>

            {/* Attendance */}
            <div
              style={{
                padding: "11px 12px",
                borderRadius: 14,
                background:
                  theme.mode === "dark"
                    ? "rgba(79,174,34,.12)"
                    : "#F4FAF1",
                border: `1px solid ${
                  theme.mode === "dark"
                    ? "rgba(79,174,34,.25)"
                    : "#DCECCF"
                }`,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 7,
                }}
              >
                <CalendarOutlined
                  style={{
                    color: "#4FAE22",
                  }}
                />

                <Text
                  style={{
                    color: theme.secondary,
                    fontSize: 11,
                  }}
                >
                  Attendance
                </Text>
              </div>

              <strong
                style={{
                  display: "block",
                  marginTop: 4,
                  color: theme.text,
                  fontSize: 13,
                  lineHeight: 1.3,
                }}
              >
                Student Presence
              </strong>
            </div>
          </div>

          {/* Bottom placeholder */}
          <div
            style={{
              marginTop: 12,
              padding: "10px 12px",
              borderRadius: 13,
              background:
                theme.mode === "dark"
                  ? "rgba(15,109,171,.12)"
                  : "#F1F7FB",
              border:
                "1px solid rgba(15,109,171,.15)",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <TeamOutlined
              style={{
                color: "#0F6DAB",
                fontSize: 15,
              }}
            />

            <Text
              style={{
                color: theme.secondary,
                fontSize: 11,
                lineHeight: 1.4,
              }}
            >
              Manage student support, counseling referrals,
              welfare concerns, and student engagement activities.
            </Text>
          </div>
        </div>
      </Card>
    </motion.div>
  );
};

export default YearlyDeanOfficialCount;


